"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-float"));
require("./Range.scss");
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _Input = _interopRequireDefault(require("./Input"));
var _excluded = ["id", "minValue", "maxValue", "step", "labels", "onChange"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context4, _context5; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context4 = ownKeys(Object(t), !0)).call(_context4, function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context5 = ownKeys(Object(t))).call(_context5, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var RangeLabels = function RangeLabels(_ref) {
  var _context, _context2, _context3;
  var rangeValue = _ref.rangeValue,
    singularUnitText = _ref.singularUnitText,
    pluralUnitText = _ref.pluralUnitText,
    minValue = _ref.minValue,
    maxValue = _ref.maxValue;
  var startLabel = minValue === 1 ? singularUnitText : pluralUnitText;
  var endLabel = maxValue === 1 ? singularUnitText : pluralUnitText;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "labels"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "sideLabel"
  }, (0, _concat["default"])(_context = "".concat(minValue, " ")).call(_context, startLabel)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "centerLabel"
  }, /*#__PURE__*/_react["default"].createElement("b", null, (0, _concat["default"])(_context2 = "".concat(rangeValue, " ")).call(_context2, rangeValue === 1 ? singularUnitText : pluralUnitText))), /*#__PURE__*/_react["default"].createElement("span", {
    className: "sideLabel"
  }, (0, _concat["default"])(_context3 = "".concat(maxValue, " ")).call(_context3, endLabel)));
};
RangeLabels.propTypes = {
  rangeValue: _propTypes.PropTypes.number.isRequired,
  singularUnitText: _propTypes.PropTypes.string.isRequired,
  pluralUnitText: _propTypes.PropTypes.string.isRequired,
  minValue: _propTypes.PropTypes.number.isRequired,
  maxValue: _propTypes.PropTypes.number.isRequired
};
var Range = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Range, _React$Component);
  var _super = _createSuper(Range);
  function Range(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Range);
    _this = _super.call(this, props);
    var _this$props = _this.props,
      defaultValue = _this$props.defaultValue,
      minValue = _this$props.minValue;
    _this.state = {
      rangeValue: defaultValue || minValue
    };
    return _this;
  }
  (0, _createClass2["default"])(Range, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var rangeValue = this.state.rangeValue;
      var _this$props2 = this.props,
        id = _this$props2.id,
        minValue = _this$props2.minValue,
        maxValue = _this$props2.maxValue,
        step = _this$props2.step,
        labels = _this$props2.labels,
        _onChange = _this$props2.onChange,
        otherProps = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var shouldDisplayLabels = labels && minValue && maxValue && labels.singularUnitText && labels.pluralUnitText;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({
        id: id,
        className: "rangeSlider",
        groupClassName: "arc-Range",
        type: "range",
        onChange: function onChange(e) {
          if (_onChange) {
            _onChange(e);
          }
          _this2.setState({
            rangeValue: (0, _parseFloat2["default"])(e.target.value)
          });
        },
        min: minValue,
        max: maxValue,
        step: step,
        value: rangeValue
      }, otherProps)), shouldDisplayLabels ? /*#__PURE__*/_react["default"].createElement(RangeLabels, _objectSpread({
        minValue: minValue,
        maxValue: maxValue,
        rangeValue: rangeValue
      }, labels)) : undefined);
    }
  }]);
  return Range;
}(_react["default"].Component);
Range.propTypes = {
  // The minimum value of the slider. For ex: `1 Mile` so minValue here is `1`
  minValue: _propTypes.PropTypes.number.isRequired,
  // The maximum value of the slider. For ex: `50 Miles` so maxValue here is `50`
  maxValue: _propTypes.PropTypes.number.isRequired,
  // Step value for Range slider to increment or decrement on change
  step: _propTypes.PropTypes.number,
  // id of the Range slider
  id: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string, _propTypes.PropTypes.number]).isRequired,
  // Value of the Range slider to default to on render
  defaultValue: _propTypes.PropTypes.number,
  // Custom onChange function to be called on Range slider value change.
  onChange: _propTypes.PropTypes.func,
  labels: _propTypes.PropTypes.shape({
    // String value indicating singular representation of unit.
    // For ex: `1 Mile` so singularUnitText here is `Mile`
    singularUnitText: _propTypes.PropTypes.string,
    // String value indicating plural representation of unit.
    // For ex: `39 Miles` so pluralUnitText here is `Miles`
    pluralUnitText: _propTypes.PropTypes.string
  })
};
Range.defaultProps = {
  step: 1,
  defaultValue: undefined,
  onChange: function onChange() {},
  labels: undefined
};
var _default = exports["default"] = Range;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Range.js
// module id = 6385
// module chunks = 25